import { render, staticRenderFns } from "./UniqueWidget.vue?vue&type=template&id=3f84d002&scoped=true"
import script from "./UniqueWidget.vue?vue&type=script&lang=js"
export * from "./UniqueWidget.vue?vue&type=script&lang=js"
import style0 from "./UniqueWidget.vue?vue&type=style&index=0&id=3f84d002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84d002",
  null
  
)

export default component.exports